import { gql } from '@apollo/client';
import { assetFragment } from '../fragments';
export const getExchangeCommissionsQuery = gql `
  query GetExchangeCommissions {
    getExchangeCommissions {
      id
      commissionRate
      fixedFee
      fromAsset {
        ...assetFields
      }
      toAsset {
        ...assetFields
      }
      greaterThan
      updatedAt
    }
  }
  ${assetFragment}
`;
//# sourceMappingURL=getExchangeCommissions.js.map